import type { UIFacet } from 'src/components/types/UIFacet';
import type { Facet } from 'src/redux/productsQuery/types/Facet';
import type { TaxonomyAttribute } from 'src/redux/productsQuery/types/ProductsQueryState';

export const adaptFacetToUIFacet = (
  facets: Facet[],
  taxonomyAttributeAliases: TaxonomyAttribute[] = [],
): UIFacet[] => {
  const facetsWithProducts = facets.filter(
    (facet) =>
      !taxonomyAttributeAliases.includes(facet.alias) &&
      facet.options.some((option) => option.count !== 0),
  );

  return facetsWithProducts.map((facet) => {
    return {
      alias: facet.alias,
      key: facet.key,
      options: facet.options.map((option) => {
        return {
          active: option.active,
          count: option.count,
          crawlable: option.crawlable ?? false,
          title: option.title,
          value: option.value,
          custom: option.custom,
        };
      }),
      title: facet.title || '',
      type: facet.type,
      ...(facet.singleOptionOnly === true ? { singleOptionOnly: true } : {}),
    };
  });
};
